import I18n from 'lib/i18n'
import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class ReputationData extends Component {
  static propTypes = {
    data: PropTypes.object,
    showChecks: PropTypes.bool
  }

  shouldComponentUpdate (nextProps, nextState) {
    return this.props.data !== nextProps.data
  }

  render () {
    const { data, showChecks } = this.props

    if (!data || data.error) {
      return null
    }

    const check = showChecks ? 'check' : 'no-check'

    return (
      <div>
        <ul className='biguserinfo in-react' style={{ margin: '0', textAlign: 'left' }}>
          <li className='member'>
            <div className={check}>
              {data.isTeacher
                ? I18n.t('profiles.profile_layout.teacher_since', { day: data.memberSince })
                : I18n.t('profiles.profile_layout.member_since', { day: data.memberSince })}
            </div>
          </li>
          {data.repeatStudentCount ? (
            <li className='repeat'>
              <div className={check}>
                {I18n.t('profiles.profile_layout.repeat_students', { count: data.repeatStudentCount })}
              </div>
            </li>
          ) : null}
          {data.phoneVerified ? (
            <li className='phone'>
              <div className={check}>{I18n.t('profiles.profile_layout.phone_verified')}</div>
            </li>
          ) : null}
          {data.socialFacebook ? (
            <li className={`facebook ${data.socialFacebookCount ? 'twoline' : ''}`}>
              <div className={check}>
                {I18n.t('profiles.profile_layout.verified_facebook')}
                {data.socialFacebookCount ? (
                  <div className='subinfo'>
                    {I18n.t('profiles.show_right.facebook_friends', { count: data.socialFacebookCount })}
                  </div>
                ) : null}
              </div>
            </li>
          ) : null}
          {data.socialGoogle ? (
            <li className='google'>
              <div className={check}>{I18n.t('profiles.profile_layout.verified_google')}</div>
            </li>
          ) : null}
          {data.socialLinkedIn ? (
            <li className={`linkedin ${data.socialLinkedInCount ? 'twoline' : ''}`}>
              <div className={check}>
                {I18n.t('profiles.profile_layout.verified_linkedin')}
                {data.socialLinkedInCount ? (
                  <div className='subinfo'>
                    {I18n.t('profiles.show_right.linkedin_connections', { count: data.socialLinkedInCount })}
                  </div>
                ) : null}
              </div>
            </li>
          ) : null}
          {data.socialTwitter ? (
            <li className='twitter'>
              <div className={check}>{I18n.t('profiles.profile_layout.verified_twitter')}</div>
            </li>
          ) : null}
        </ul>
      </div>
    )
  }
}
